
export default {
  // sentences----
  "/sentences/classify/list":{
    page: 1,
    pageSize: 10,
    totalCount: 20,
    totalPages: 2,
    list: [
      {
        id: 1,
        classifyId: 1,
        classifyName: '问候',
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
      {
        id: 2,
        classifyId: 2,
        classifyName: '购物',
        createTime: '1749020874379',
        updateTime: '1749020874379'
      },
    ],
  },
};
